import { render, staticRenderFns } from "./OrmBatchingDetail.vue?vue&type=template&id=746cc3c8&scoped=true"
import script from "./OrmBatchingDetail.vue?vue&type=script&lang=js"
export * from "./OrmBatchingDetail.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchingDetail.vue?vue&type=style&index=0&id=746cc3c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746cc3c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('746cc3c8')) {
      api.createRecord('746cc3c8', component.options)
    } else {
      api.reload('746cc3c8', component.options)
    }
    module.hot.accept("./OrmBatchingDetail.vue?vue&type=template&id=746cc3c8&scoped=true", function () {
      api.rerender('746cc3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingDetail.vue"
export default component.exports